import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { SesionService } from './sesion.service';
import { UtilsService } from './utils.service';
import { AppConstants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class ResolverService implements Resolve<any> {
  constructor(private sesionService: SesionService, private utilsService: UtilsService) { }

  resolve(route: ActivatedRouteSnapshot) {
    if (window.location.href.includes('/votaciones/emitirvoto') && window.location.href.includes('?token='))
      this.utilsService.setLocalStorage('emitirvoto', window.location.href, false);
    else
      this.utilsService.removeLocalStorage('emitirvoto');
    if (window.location.href.includes('/votaciones/verresultados') && window.location.href.includes('?token='))
      this.utilsService.setLocalStorage('verresultados', window.location.href, false);
    else
      this.utilsService.removeLocalStorage('verresultados');
    if (this.sesionService.validarSesion()) {
      return;
    } else {
      this.utilsService.redirectPath([AppConstants.APLICATION_MODULES.LOGIN.ruta], true);
    }
  }
}
